import type { Node } from "@xyflow/react";
import { HERO_CONCEPTS, STOCK } from "../theme";
import { ICON_CATS, ICON_LIB } from "../nodes/icons";

export function band3Assets(bust: string): Node[] {
  const out: Node[] = [];
  const BAND3_TITLE_Y = 26000; // moved down to clear the tall ~9700px mobile compare frames (bottom ~19150) in band 2
  const ZG = 700;
    out.push({ id: "band-assets", type: "sectionTitle", position: { x: 0, y: BAND3_TITLE_Y },
      data: { title: "Assets & Design", sub: "logo directions, hero art, and stock — each contained in its own box", band: true }, draggable: false, selectable: false });
    // ── BAND 3: ASSETS DESIGN — CONTAINED boxes, well below the rest (Leo, 2026-07-08).
    // No endless columns: logos gridded 4-wide; heroes + stock as bounded gallery boxes.
    const ASSETS_Y = BAND3_TITLE_Y + 520; // content starts below the band super-title
    const bustNum = bust.replace("?t=", "");

    // LOGO LAB — 16 direction boxes tidied into a 4×4 grid (was one 16-wide row).
    const LOGO_COLS = 4, LOGO_PITCH_X = 760, LOGO_PITCH_Y = 520;
    ICON_CATS.forEach((cat, i) => {
      out.push({
        id: `logo-${cat.id}`, type: "logoCategory",
        position: { x: (i % LOGO_COLS) * LOGO_PITCH_X, y: ASSETS_Y + Math.floor(i / LOGO_COLS) * LOGO_PITCH_Y },
        data: { ...cat, bust: bustNum }, draggable: false, selectable: false,
      });
    });
    const logoGridW = LOGO_COLS * LOGO_PITCH_X; // right edge of the logo grid

    // HERO CONCEPTS — bounded gallery box (grid of thumbnails), not a tall lane.
    const heroBoxX = logoGridW + ZG;
    out.push({
      id: "assets-heroes", type: "galleryBox", position: { x: heroBoxX, y: ASSETS_Y },
      data: {
        title: "Hero concepts", tag: "TESTING · newest first",
        sub: "every hero render we've made — the live base is tall2",
        cols: 4, cellH: 150, boxW: 1180,
        items: HERO_CONCEPTS.map((h) => ({ img: `${h.img}${bust}`, label: h.label })),
      },
      draggable: false, selectable: false,
    });

    // STOCK CANDIDATES — a second bounded gallery box.
    const stockBoxX = heroBoxX + 1180 + ZG;
    out.push({
      id: "assets-stock", type: "galleryBox", position: { x: stockBoxX, y: ASSETS_Y },
      data: {
        title: "Stock candidates", tag: "TESTING · real photos",
        sub: "HD stock in the duna look — pick a vibe, mock it as hero",
        cols: 3, cellH: 150, boxW: 900,
        items: STOCK.map((s) => ({ img: s.img, label: s.label })),
      },
      draggable: false, selectable: false,
    });

    // ICON LIBRARY — a picker gallery of clean Lucide (shadcn) icons for the site (Erez, 2026-07-10).
    // Approve a set per section and Leo swaps them onto the homepage.
    out.push({
      id: "assets-icon-title", type: "sectionTitle", position: { x: 0, y: ASSETS_Y + 2260 },
      data: { title: "Icon library — pick for the site", sub: "clean light Lucide icons (what shadcn uses), closer to Duna — approve a set and I swap them in" },
      draggable: false, selectable: false,
    });
    out.push({
      id: "assets-icon-gallery", type: "iconGallery", position: { x: 0, y: ASSETS_Y + 2560 },
      data: { groups: ICON_LIB },
      draggable: false, selectable: false,
    });

  return out;
}
